export function MyorderModel(dict) {
    this.address = dict.Address;
    this.agencyLocationId = dict.AgencyLocationId;
    this.buCode = dict.BUCode;
    this.branchAddress = dict.BranchAddress;
    this.branchContactNumber = null;
    try {
        this.branchContactNumber = JSON.parse(dict.BranchContactNumber);
    } catch (error) {
        console.log(error);
    }
    this.branchId = dict.BranchId;
    this.branchName = dict.BranchName;
    this.branchNameEN = dict.BranchNameEN;
    this.burgerkingSubsidy = dict.BurgerkingSubsidy;
    this.bzbsStatus = dict.BzbsStatus;
    this.bzbsStatusName = dict.BzbsStatusName;
    this.campaignAmount = dict.CampaignAmount;
    this.cancelDate = dict.CancelDate;
    this.channel = dict.Channel;
    this.completeDate = dict.CompleteDate;
    this.createDate = dict.CreateDate;
    this.cscHistoryKey = dict.CscHistoryKey;
    this.cscOrderKey = dict.CscOrderKey;
    this.customerLatitude = dict.CustomerLatitude;
    this.customerLongitude = dict.CustomerLongitude;
    this.deliveryCancel = dict.DeliveryCancel;
    this.deliveryComplete = dict.DeliveryComplete;
    this.deliveryDiscount = dict.DeliveryDiscount;
    this.deliveryDiscountBatchId = dict.DeliveryDiscountBatchId;
    this.deliveryDiscountReferenceCode = dict.DeliveryDiscountReferenceCode;
    this.deliveryPickup = dict.DeliveryPickup;
    this.deliveryStatus = dict.DeliveryStatus;
    this.deliveryStatusName = dict.DeliveryStatusName;
    this.deliveryStatusUpdatedDate = dict.DeliveryStatusUpdatedDate;
    this.deliveryType = dict.DeliveryType;
    this.discount = dict.Discount;
    this.discountBatchId = dict.DiscountBatchId;
    this.discountReferenceCode = dict.DiscountReferenceCode;
    this.distance = dict.Distance;
    this.districtName = dict.DistrictName;
    this.eTag = dict.ETag;
    this.earnPoints = dict.EarnPoints;
    this.earnPointsDate = dict.EarnPointsDate;
    this.expectDelivery = dict.ExpectDelivery;
    this.grabDeliveryDriverContactNumber = dict.GrabDeliveryDriverContactNumber;
    this.grabDeliveryDriverName = dict.GrabDeliveryDriverName;
    this.grabDeliveryFee = dict.GrabDeliveryFee;
    this.grabDeliveryId = dict.GrabDeliveryId;
    this.grabDeliveryJson = dict.GrabDeliveryJson;
    this.isFavourite = dict.IsFavourite;
    this.isSubscription = dict.IsSubscription;
    this.lalamoveCustomerOrderId = dict.LalamoveCustomerOrderId;
    this.lalamoveDeliveryFee = dict.LalamoveDeliveryFee;
    this.lalamoveDriverContactNumber = dict.LalamoveDriverContactNumber;
    this.lalamoveDriverId = dict.LalamoveDriverId;
    this.lalamoveDriverName = dict.LalamoveDriverName;
    this.lalamoveJson = dict.LalamoveJson;
    this.lalamoveOrderRef = dict.LalamoveOrderRef;
    this.name = dict.Name;
    this.orderPlan = dict.OrderPlan;
    this.orderType = dict.OrderType;
    this.partitionKey = dict.PartitionKey;
    this.pickUpDate = dict.PickUpDate;
    this.pointDiscountCampaignId = dict.PointDiscountCampaignId;
    this.pointDiscountItemNumber = dict.PointDiscountItemNumber;
    this.pointDiscountReferenceCode = dict.PointDiscountReferenceCode;
    this.pointLogReportKey = dict.PointLogReportKey;
    this.provinceName = dict.ProvinceName;
    this.region = dict.Region;
    this.rowKey = dict.RowKey;
    this.runningId = dict.RunningId;
    this.scheduleAt = dict.ScheduleAt;
    this.sdmOrderId = dict.SdmOrderId;
    this.shippingAmount = dict.ShippingAmount;
    this.subDistrictName = dict.SubDistrictName;
    this.taxAddress = dict.TaxAddress;
    this.taxBranchId = dict.TaxBranchId;
    this.taxId = dict.TaxId;
    this.taxName = dict.TaxName;
    this.thirdPartyDeliveryFee = dict.ThirdPartyDeliveryFee;
    this.thirdPartyDeliveryId = dict.ThirdPartyDeliveryId;
    this.timestamp = dict.Timestamp;
    this.tranAmount = dict.TranAmount;
    this.tranId = dict.TranId;
    this.userId = dict.UserId;
    this.userRemark = dict.UserRemark;
    this.vendorStatus = dict.VendorStatus;
    this.vendorStatusName = dict.VendorStatusName;
    this.vendorStatusUpdatedDate = dict.VendorStatusUpdatedDate;
    this.zipcode = dict.Zipcode;
    this.items = []

    let itemArr = dict?.items ?? []
    if(itemArr.length > 0){
        for (const item of itemArr) {
            this.items.push(new MyorderDetailModel(item))
        }
    }
}

export function MyorderDetailModel(dict) {
    this.bzbsStatus = dict.BzbsStatus;
    this.bzbsStatusName = dict.BzbsStatusName;
    this.campaignId = dict.CampaignId;
    this.eTag = dict.ETag;
    this.extra = dict.Extra;
    this.isPromotionCampaign = dict.IsPromotionCampaign;
    this.masterCampaignId = dict.MasterCampaignId;
    this.name = dict.Name;
    this.nameEN = dict.NameEN;
    this.partitionKey = dict.PartitionKey;
    this.pricePerUnit = dict.PricePerUnit;
    this.quantity = dict.Quantity;
    this.referenceCode = dict.ReferenceCode;
    this.remark = dict.Remark;
    this.rowKey = dict.RowKey;
    this.styleJson = null;
    try {
        this.styleJson = JSON.parse(dict.StyleJson);
    } catch (error) {
        console.log(error);
    }
    try {
        this.extra = JSON.parse(dict.Extra);
    } catch (error) {
        console.log(error);
    }
    try {
        this.remark = JSON.parse(dict.Remark);
    } catch (error) {
        console.log(error);
    }
    this.timestamp = dict.Timestamp;
    this.totalAmount = dict.TotalAmount;
    this.addons = dict.Addons;
    this.ingredients = dict.Ingredients;
    this.appetizers = dict.Appetizers;
    this.others = dict.Others;
    // this.chooses = [];

    // const indexAll = [];
    // let indexMax = null;
    // for (const addonsItem of this.addons) {
    //     indexAll.push(addonsItem.Index)
    // }
    // for (const addonsItem of this.ingredients) {
    //     indexAll.push(addonsItem.Index)
    // }
    
    // if (indexAll.length > 0) {
    //     indexMax = Math.max(...indexAll)
    //     for (let i = 0; i <= indexMax; i++) {
    //         for (const addonsItem of this.addons) {
    //             if (addonsItem.Index == i) {
    //                 if (this.chooses[i] == undefined) {
    //                     this.chooses.push({
    //                         header: addonsItem.Header,
    //                         headerEN: addonsItem.HeaderEN,
    //                         addonItems: addonsItem.Items,
    //                         ingredientItems: []
    //                     }) 
    //                 } else {
    //                     this.chooses[i].addonItems = addonsItem.Items
    //                 }
    //             }
    //         }

    //         for (const ingredientItem of this.ingredients) {
    //             if (ingredientItem.Index == i) {
    //                 if (this.chooses[i] == undefined) {
    //                     this.chooses.push({
    //                         header: ingredientItem.Header,
    //                         headerEN: ingredientItem.HeaderEN,
    //                         addonItems: [],
    //                         ingredientItems: ingredientItem.Items
    //                     }) 
    //                 } else {
    //                     this.chooses[i].ingredientItems = ingredientItem.Items
    //                 }
    //             }
    //         }
    //     }

    //     console.log("chooses",this.chooses)
    // }


    
    
    
}
